import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-perfil-personal',
  templateUrl: './perfil-personal.component.html',
  styleUrls: ['./perfil-personal.component.scss']
})
export class PerfilPersonalComponent implements OnInit {

  @Input() InfoPersonal  : any = [];

  constructor() { }

  ngOnInit(): void {
  }

  abrirPerfil(): void {

  }
}
